import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/site/Navbar";
import Hero from "@/site/Hero";
import Services from "@/site/Services";
import Manifesto from "@/site/Manifesto";
import Stats from "@/site/Stats";
import Gallery from "@/site/Gallery";
import Contact from "@/site/Contact";
import Footer from "@/site/Footer";
import Impressum from "@/site/Impressum";
import AGB from "@/site/AGB";
import Datenschutz from "@/site/Datenschutz";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [impressumOpen, setImpressumOpen] = useState(false);
  const [agbOpen, setAgbOpen] = useState(false);
  const [datenschutzOpen, setDatenschutzOpen] = useState(false);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain bg-[#0d0d0f]" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Manifesto />
        <Stats />
        <Gallery />
        <Contact />
      </main>
      <Footer
        onOpenImpressum={() => setImpressumOpen(true)}
        onOpenAgb={() => setAgbOpen(true)}
        onOpenDatenschutz={() => setDatenschutzOpen(true)}
      />
      <Impressum open={impressumOpen} onClose={() => setImpressumOpen(false)} />
      <AGB open={agbOpen} onClose={() => setAgbOpen(false)} />
      <Datenschutz open={datenschutzOpen} onClose={() => setDatenschutzOpen(false)} />
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}

export default App;
